// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorUI_error__cQiRW","icon":"ErrorUI_icon__SW4lM","errorMessage":"ErrorUI_errorMessage__i4Btv"};